import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { DTB } from 'views/App/Portal/DTB/_types/dtb';

export const createDTB = async (
  orgId: string,
  data: Record<string, any>,
  callback?: (data: DTB) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  if (!orgId) throw new Error('No organization ID provided.');
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs`;
  await fetcher({
    url,
    method: 'POST',
    body: data,
  })
    .then((response) => {
      if (callback) callback(response);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const updateDTB = async (
  orgId: string,
  id: string,
  data: DTB,
  callback?: (data: DTB) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  if (!orgId) throw new Error('No organization ID provided.');
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs/${id}`;
  try {
    const response = await fetcher({
      url,
      method: 'PUT',
      body: data,
    });
    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) handleError(err, { onError });
    throw err;
  }
};

export const deleteDTB = async (
  orgId: string,
  id: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  if (!orgId) throw new Error('No organization ID provided.');
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs/${id}`;
  await fetcher({
    url,
    method: 'DELETE',
    body: {},
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const cloneDTB = async (
  orgId: string,
  dtbPackageId: string,
  name: string,
  jurisdictionId?: string,
  manualId?: string,
  level?: 'AGENCY' | 'JURISDICTION' | 'GLOBAL',
  verticalId?: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  if (!orgId) throw new Error('No organization ID provided.');
  if (!dtbPackageId) throw new Error('No DTB package ID provided.');
  if (!name) throw new Error('No name provided.');
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/packages/${dtbPackageId}/clone`;

  const body: Record<string, any> = { name };
  if (jurisdictionId) body.jurisdictionId = jurisdictionId;
  if (manualId) body.manualId = manualId;
  if (level) body.level = level;
  if (verticalId) body.verticalId = verticalId;

  await fetcher({
    url,
    method: 'POST',
    body,
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const getDTBLock = async (
  orgId: string,
  dtbId: string,
  callback?: (data: any) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  if (!orgId) throw new Error('No organization ID provided.');
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs/${dtbId}/lock`;
  await fetcher({
    url,
    method: 'POST',
    body: {},
  })
    .then((response) => {
      if (callback) callback(response);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const takeDTBLock = async (
  orgId: string,
  dtbId: string,
  callback?: (data: any) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs/${dtbId}/lock`;
  await fetcher({
    url,
    method: 'PATCH',
    body: {},
  })
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const removeDTBLock = async (
  orgId: string,
  dtbId: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  if (!orgId) throw new Error('No organization ID provided.');
  const url = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${orgId}/dtbs/${dtbId}/lock`;
  await fetcher({
    url,
    method: 'DELETE',
    body: {},
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};
